import Form from '../components/Form';
import 'form-serializer';

class CookieForm extends Form {
  setupDefaults() {
    super.setupDefaults();

    this.endpoint = this.$el.attr('action');

    this.dom = {
      ...this.dom,
      $submitBtn: this.$el.find('input[type="submit"]'),
      $notice: $('#privacy-notice')
    };
  }

  addListeners() {
    this.$el.on('submit', :: this.onCookieSubmit);
    this.dom.$notice.show();
  }

  onCookieSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.$el[0].checkValidity()) {
      this.submitCookie();
    }
  }

  async submitCookie() {
    this.dom.$submitBtn.attr('disabled', 'disabled').parent().addClass('is-loading');
    const res = await this.postCookie();

    if (res.success) {
      this.dom.$notice.hide();
    } else {
      this.clearFormLevelError();
      this.displayFormLevelError(res.message);
      this.dom.$submitBtn.removeAttr('disabled').parent().removeClass('is-loading');
    }
  }

  postCookie() {
    const data = this.$el.serializeJSON();
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data
    })
  }
}

export default CookieForm;



// WEBPACK FOOTER //
// ./src/bb/js/components/CookieForm.js